// Define the types for the testimonials
export interface Testimonial {
    commentFr: string;
    commentEn: string;
    commenter: string;
    note: number;
    dateFr: string;
    dateEn: string;
    source: string;
  }
  
  // Cars Testimonial data array
  export const testimonialDataCars: Testimonial[] = [
    {
        commentFr: "Service impeccable, voiture en excellent état. Je suis vraiment satisfait.",
        commentEn: "Impeccable service, car in excellent condition. I'm really satisfied.",
        commenter: "Jean L.",
        note: 5,
        dateFr: "Mars 2024",
        dateEn: "March 2024",
        source: "Google"
    },
    {
        commentFr: "Voiture propre et bien entretenue, mais le service client pourrait être amélioré.",
        commentEn: "Clean and well-maintained car, but customer service could be improved.",
        commenter: "Marie P.",
        note: 4,
        dateFr: "Mars 2024",
        dateEn: "March 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "Le processus de réservation était simple et rapide. Je recommande vivement.",
        commentEn: "The booking process was simple and fast. I highly recommend.",
        commenter: "Paul D.",
        note: 5,
        dateFr: "Mars 2024",
        dateEn: "March 2024",
        source: "Yelp"
    },
    {
        commentFr: "Bonne voiture mais trop de paperasse à remplir. Cela aurait pu être plus simple.",
        commentEn: "Good car but too much paperwork to fill out. It could have been simpler.",
        commenter: "Sophie M.",
        note: 3,
        dateFr: "Avril 2024",
        dateEn: "April 2024",
        source: "Google"
    },
    {
        commentFr: "Voiture récente et très propre. Aucun problème pendant la location.",
        commentEn: "Recent and very clean car. No issues during the rental.",
        commenter: "Lucas T.",
        note: 5,
        dateFr: "Avril 2024",
        dateEn: "April 2024",
        source: "Google"
    },
    {
        commentFr: "Louer la voiture était facile, mais j'aurais aimé plus d'options économiques.",
        commentEn: "Renting the car was easy, but I wish there were more budget options.",
        commenter: "Emma K.",
        note: 4,
        dateFr: "Avril 2024",
        dateEn: "April 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "Expérience correcte, mais la voiture n'était pas aussi propre que je l'aurais souhaité.",
        commentEn: "Decent experience, but the car wasn't as clean as I would have liked.",
        commenter: "Nicolas B.",
        note: 3,
        dateFr: "Mai 2024",
        dateEn: "May 2024",
        source: "Yelp"
    },
    {
        commentFr: "Excellent service client, la voiture était parfaite pour mon voyage.",
        commentEn: "Excellent customer service, the car was perfect for my trip.",
        commenter: "Clara H.",
        note: 5,
        dateFr: "Mai 2024",
        dateEn: "May 2024",
        source: "Google"
    },
    {
        commentFr: "Bonne expérience globale, mais un peu cher pour ce que c'était.",
        commentEn: "Overall good experience, but a bit pricey for what it was.",
        commenter: "Hugo F.",
        note: 4,
        dateFr: "Mai 2024",
        dateEn: "May 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "Je suis un peu déçu par l'état des pneus. Cela m'a inquiété pendant tout le voyage.",
        commentEn: "I'm a bit disappointed with the condition of the tires. It worried me throughout the trip.",
        commenter: "Elise V.",
        note: 3,
        dateFr: "Juin 2024",
        dateEn: "June 2024",
        source: "Google"
    },
    {
        commentFr: "La voiture était en parfait état et le personnel était très serviable.",
        commentEn: "The car was in perfect condition and the staff was very helpful.",
        commenter: "Alexandre J.",
        note: 5,
        dateFr: "Juin 2024",
        dateEn: "June 2024",
        source: "Yelp"
    },
    {
        commentFr: "Service rapide et efficace, je reviendrai certainement.",
        commentEn: "Quick and efficient service, I will definitely come back.",
        commenter: "Julie N.",
        note: 5,
        dateFr: "Juin 2024",
        dateEn: "June 2024",
        source: "Google"
    },
    {
        commentFr: "Bonne expérience mais j'ai trouvé les frais supplémentaires un peu élevés.",
        commentEn: "Good experience, but I found the extra fees a bit high.",
        commenter: "Thomas W.",
        note: 4,
        dateFr: "Juin 2024",
        dateEn: "June 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "Le GPS de la voiture ne fonctionnait pas bien, ce qui a causé des soucis.",
        commentEn: "The car's GPS wasn't working well, which caused some issues.",
        commenter: "Lucie R.",
        note: 3,
        dateFr: "Juillet 2024",
        dateEn: "July 2024",
        source: "Google"
    },
    {
        commentFr: "Service client exceptionnel, je suis très satisfait de ma location.",
        commentEn: "Exceptional customer service, I'm very satisfied with my rental.",
        commenter: "Vincent S.",
        note: 5,
        dateFr: "Juillet 2024",
        dateEn: "July 2024",
        source: "Google"
    },
    {
        commentFr: "Facile à réserver, la voiture était propre et confortable.",
        commentEn: "Easy to book, the car was clean and comfortable.",
        commenter: "Chloé L.",
        note: 5,
        dateFr: "Juillet 2024",
        dateEn: "July 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "L'état de la voiture était bon, mais la prise en charge était lente.",
        commentEn: "The condition of the car was good, but the pick-up was slow.",
        commenter: "Martin G.",
        note: 4,
        dateFr: "Juillet 2024",
        dateEn: "July 2024",
        source: "Yelp"
    },
    {
        commentFr: "Pas mal, mais je m'attendais à mieux en termes de service.",
        commentEn: "Not bad, but I expected better in terms of service.",
        commenter: "Laura B.",
        note: 3,
        dateFr: "Août 2024",
        dateEn: "August 2024",
        source: "Google"
    },
    {
        commentFr: "Voiture parfaite pour mon voyage, tout s'est très bien passé.",
        commentEn: "Perfect car for my trip, everything went very smoothly.",
        commenter: "Olivier K.",
        note: 5,
        dateFr: "Août 2024",
        dateEn: "August 2024",
        source: "Google"
    },
    {
        commentFr: "Bon rapport qualité-prix, je suis satisfait de la location.",
        commentEn: "Good value for money, I'm satisfied with the rental.",
        commenter: "Isabelle T.",
        note: 4,
        dateFr: "Août 2024",
        dateEn: "August 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "La voiture avait une odeur étrange, mais elle fonctionnait bien.",
        commentEn: "The car had a strange smell, but it worked fine.",
        commenter: "Matthieu R.",
        note: 3,
        dateFr: "Août 2024",
        dateEn: "August 2024",
        source: "Yelp"
    },
    {
        commentFr: "Service de qualité, je recommande vivement cette agence.",
        commentEn: "Quality service, I highly recommend this agency.",
        commenter: "Camille F.",
        note: 5,
        dateFr: "Mars 2024",
        dateEn: "March 2024",
        source: "Google"
    },
    {
        commentFr: "Voiture en excellent état et facile à conduire. Très satisfait.",
        commentEn: "Car in excellent condition and easy to drive. Very satisfied.",
        commenter: "Julien E.",
        note: 5,
        dateFr: "Avril 2024",
        dateEn: "April 2024",
        source: "Google"
    },
    {
        commentFr: "Bonne voiture mais la prise en charge a pris plus de temps que prévu.",
        commentEn: "Good car but the pick-up took longer than expected.",
        commenter: "Élodie V.",
        note: 4,
        dateFr: "Mai 2024",
        dateEn: "May 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "Le service était correct, mais la voiture avait quelques rayures.",
        commentEn: "The service was okay, but the car had some scratches.",
        commenter: "Damien L.",
        note: 3,
        dateFr: "Juin 2024",
        dateEn: "June 2024",
        source: "Google"
    },
    {
        commentFr: "Service impeccable, la voiture était comme neuve. Très satisfait.",
        commentEn: "Impeccable service, the car was like new. Very satisfied.",
        commenter: "Sabrina D.",
        note: 5,
        dateFr: "Juillet 2024",
        dateEn: "July 2024",
        source: "Google"
    },
    {
        commentFr: "Expérience fluide, la voiture était très agréable à conduire.",
        commentEn: "Smooth experience, the car was very pleasant to drive.",
        commenter: "Marc Z.",
        note: 5,
        dateFr: "Août 2024",
        dateEn: "August 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "Pas de problèmes majeurs, mais j'ai trouvé le processus un peu long.",
        commentEn: "No major issues, but I found the process a bit lengthy.",
        commenter: "Amélie B.",
        note: 4,
        dateFr: "Mars 2024",
        dateEn: "March 2024",
        source: "Yelp"
    },
    {
        commentFr: "Voiture confortable mais la radio ne fonctionnait pas.",
        commentEn: "Comfortable car, but the radio didn't work.",
        commenter: "Antoine H.",
        note: 3,
        dateFr: "Avril 2024",
        dateEn: "April 2024",
        source: "Google"
    },
    {
        commentFr: "Très bon service, je suis extrêmement satisfait de ma location.",
        commentEn: "Very good service, I'm extremely satisfied with my rental.",
        commenter: "Anaïs P.",
        note: 5,
        dateFr: "Mai 2024",
        dateEn: "May 2024",
        source: "Google"
    },
    {
        commentFr: "Facile à louer, voiture en bon état et personnel serviable.",
        commentEn: "Easy to rent, car in good condition and helpful staff.",
        commenter: "Adrien M.",
        note: 5,
        dateFr: "Juin 2024",
        dateEn: "June 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "Bonne expérience, mais j'ai eu du mal à trouver le bureau de location.",
        commentEn: "Good experience, but I had trouble finding the rental office.",
        commenter: "Noémie J.",
        note: 4,
        dateFr: "Juillet 2024",
        dateEn: "July 2024",
        source: "Yelp"
    },
    {
        commentFr: "Voiture en bon état mais le réservoir de carburant n'était pas plein.",
        commentEn: "Car in good condition but the fuel tank wasn't full.",
        commenter: "Romain V.",
        note: 3,
        dateFr: "Août 2024",
        dateEn: "August 2024",
        source: "Google"
    },
    {
        commentFr: "Expérience parfaite, je recommande vivement cette agence.",
        commentEn: "Perfect experience, I highly recommend this agency.",
        commenter: "Charlotte L.",
        note: 5,
        dateFr: "Mars 2024",
        dateEn: "March 2024",
        source: "Google"
    },
    {
        commentFr: "Location simple et rapide, voiture propre et en bon état.",
        commentEn: "Simple and fast rental, clean car in good condition.",
        commenter: "Benoît F.",
        note: 5,
        dateFr: "Avril 2024",
        dateEn: "April 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "Bon service, mais j'ai dû attendre longtemps pour récupérer la voiture.",
        commentEn: "Good service, but I had to wait a long time to pick up the car.",
        commenter: "Audrey C.",
        note: 4,
        dateFr: "Mai 2024",
        dateEn: "May 2024",
        source: "Yelp"
    },
    {
        commentFr: "Voiture fonctionnelle mais les freins étaient un peu usés.",
        commentEn: "Functional car but the brakes were a bit worn.",
        commenter: "Guillaume R.",
        note: 3,
        dateFr: "Juin 2024",
        dateEn: "June 2024",
        source: "Google"
    },
    {
        commentFr: "Service impeccable, je n'ai rien à redire. Très satisfait.",
        commentEn: "Impeccable service, I have no complaints. Very satisfied.",
        commenter: "Émilie S.",
        note: 5,
        dateFr: "Juillet 2024",
        dateEn: "July 2024",
        source: "Google"
    },
    {
        commentFr: "Réservation facile, voiture en très bon état. Je recommande.",
        commentEn: "Easy booking, car in very good condition. I recommend.",
        commenter: "Maxime L.",
        note: 5,
        dateFr: "Août 2024",
        dateEn: "August 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "Bonne voiture mais j'ai eu du mal à la retourner en raison du trafic.",
        commentEn: "Good car but I had trouble returning it due to traffic.",
        commenter: "Louise A.",
        note: 4,
        dateFr: "Mars 2024",
        dateEn: "March 2024",
        source: "Yelp"
    },
    {
        commentFr: "La voiture était en bon état mais l'interface du GPS était déroutante.",
        commentEn: "The car was in good condition but the GPS interface was confusing.",
        commenter: "Hélène M.",
        note: 3,
        dateFr: "Avril 2024",
        dateEn: "April 2024",
        source: "Google"
    },
    {
        commentFr: "Très bon service, voiture comme neuve. Très content de ma location.",
        commentEn: "Great service, car like new. Very happy with my rental.",
        commenter: "Sébastien P.",
        note: 5,
        dateFr: "Mai 2024",
        dateEn: "May 2024",
        source: "Google"
    },
    {
        commentFr: "Réservation rapide, voiture en excellent état. Je recommande.",
        commentEn: "Quick booking, car in excellent condition. I recommend.",
        commenter: "Aurélie G.",
        note: 5,
        dateFr: "Juin 2024",
        dateEn: "June 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "Bonne expérience, mais un peu cher pour la durée de location.",
        commentEn: "Good experience, but a bit expensive for the rental duration.",
        commenter: "Tristan D.",
        note: 4,
        dateFr: "Juillet 2024",
        dateEn: "July 2024",
        source: "Yelp"
    },
    {
        commentFr: "Voiture propre mais le système de climatisation ne fonctionnait pas correctement.",
        commentEn: "Clean car but the air conditioning system didn't work properly.",
        commenter: "Manon E.",
        note: 3,
        dateFr: "Août 2024",
        dateEn: "August 2024",
        source: "Google"
    },
    {
        commentFr: "Service client fantastique, je louerai certainement à nouveau.",
        commentEn: "Fantastic customer service, I will definitely rent again.",
        commenter: "Cédric N.",
        note: 5,
        dateFr: "Mars 2024",
        dateEn: "March 2024",
        source: "Google"
    },
    {
        commentFr: "Voiture récente et bien entretenue, tout s'est bien passé.",
        commentEn: "Recent and well-maintained car, everything went well.",
        commenter: "Laure B.",
        note: 5,
        dateFr: "Avril 2024",
        dateEn: "April 2024",
        source: "TripAdvisor"
    },
    {
        commentFr: "Bonne voiture mais l'expérience aurait pu être meilleure.",
        commentEn: "Good car but the experience could have been better.",
        commenter: "Bastien V.",
        note: 4,
        dateFr: "Mai 2024",
        dateEn: "May 2024",
        source: "Yelp"
    },
    {
        commentFr: "La voiture avait quelques problèmes mécaniques, ce qui était inquiétant.",
        commentEn: "The car had some mechanical issues, which was concerning.",
        commenter: "Aurélien G.",
        note: 3,
        dateFr: "Juin 2024",
        dateEn: "June 2024",
        source: "Google"
    },
    {
        commentFr: "Service exceptionnel, voiture en parfait état. Très satisfait.",
        commentEn: "Exceptional service, car in perfect condition. Very satisfied.",
        commenter: "Catherine L.",
        note: 5,
        dateFr: "Juillet 2024",
        dateEn: "July 2024",
        source: "Google"
    }
];
